import { Injectable } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KeyboardShortcutsService {
  private _shortcuts = new Map<string, Subject<void>>();
  private shiftPressed = false;

  constructor(private _eventManager: EventManager) {
    this._eventManager.addEventListener(document as any, 'keydown.shift', () => {
      this.shiftPressed = true;
    });
    this._eventManager.addEventListener(document as any, 'keyup.shift', () => {
      this.shiftPressed = false;
    });
  }

  addShortcut(keys: string): Observable<void> {
    // Si le shortcut existe déjà, retourne son observable
    if (this._shortcuts.has(keys)) {
      return this._shortcuts.get(keys)!.asObservable();
    }

    const subject = new Subject<void>();
    const event = `keydown.${keys}`;

    const handler = (e: KeyboardEvent) => {
      if (e.repeat) return; // Ignore les répétitions
      e.preventDefault();
      subject.next();
    };

    this._eventManager.addEventListener(document as any, event, handler);
    this._shortcuts.set(keys, subject);

    return subject.asObservable();
  }

  isShiftPressed(): boolean {
    return this.shiftPressed;
  }

  isMac(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('mac');
  }
}
